import { HTMLProps } from 'react'

export type MdSpanProps = HTMLProps<HTMLSpanElement>

export const MdSpan = ({ children, ...rest }: MdSpanProps) => {
  return <span {...rest}>{children}</span>
}
